export interface ICardProjects {
    name: string,
    about: string,
    preview: string,
    url: string
}

export const projects: ICardProjects[] = [
    {
        name: "Comming soon",
        about: "",
        preview: "/assets/images/building.png",
        url: "#"
    },
    {
        name: "Comming soon",
        about: "",
        preview: "/assets/images/building-2.png",
        url: "#"
    },
    {
        name: "Comming soon",
        about: "",
        preview: "/assets/images/building-3.png",
        url: "#"
    }
]